import { Component, type ErrorInfo, type ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    // Logged locally only; never includes financial data or credentials.
    console.error('Unhandled application error', error, info.componentStack);
  }

  override render() {
    if (this.state.hasError) {
      return (
        <main className="error-boundary-screen" role="alert">
          <h1>Something went wrong</h1>
          <p>
            This view ran into an unexpected error. Your saved financial data is unaffected, but
            this screen cannot continue.
          </p>
          <button className="button primary" onClick={() => window.location.reload()}>
            Reload application
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
